<template>
    <div class="wrap">
        <div class="container">
          <img class="ykf" @click="tokf" src="../images/ykefu.png" alt="" srcset="">
            <van-row class="yhbg" type="flex" align="center" justify="start" v-if="user_info">
                <van-col class="yh_tx">
                    <van-image round width="60" height="60" :src="user_info.avatar"/>
                </van-col>
                <van-col style="margin-left: -8px;">
                    <p class="yh_name">{{user_info.nickname||'你好'}}</p>
                    <p>ID: {{user_info.id}}</p>
                </van-col>
            </van-row>
            <van-row class="yhbg" type="flex" align="center" justify="start" v-if="!user_info">
                <van-col class="yh_tx">
                    <van-image round width="60" height="60" src="https://www.jqxtech.com/images/morenimg.png" />
                </van-col>
                <van-col>
                    <p class="yh_name">
                      <router-link to="/login">请登录</router-link>
                    </p>                    
                    <p></p>
                </van-col>
            </van-row>
             <div class="dingdan">
              <div class="dingdannan">我的订单</div>
              <div class="dingdans">
                <div class="dingdanotem" @click="goorder('All')">
                  <div class="dingdaitip" :class="{'dingdaitip1':ordernum.total>100}" v-if="ordernum.total>0" style="">{{ ordernum?.total }}</div>
                  <img src="../images/quanb.png" class="dingdanotemimg" mode="heightFix" alt="">
                  <div class="dingdanotemtet">全部</div>
                </div>
                <div class="dingdanotem" @click="goorder('Unpaid')">
                  <div class="dingdaitip" :class="{'dingdaitip1':ordernum.unpaidTotal>100}" v-if="ordernum.unpaidTotal>0" style="">{{ ordernum.unpaidTotal }}</div>
                  <img src="../images/daizhif.png" class="dingdanotemimg" mode="heightFix" alt="">
                  <div class="dingdanotemtet">待支付</div>
                </div>
                <div class="dingdanotem" @click="goorder('Received')">
                  <div class="dingdaitip" :class="{'dingdaitip1':ordernum.finishTotal>100}" v-if="ordernum.finishTotal>0" style="">{{ ordernum.finishTotal }}</div>
                  <img src="../images/daifah.png" class="dingdanotemimg" mode="heightFix" alt="">
                  <div class="dingdanotemtet">已完成</div>
                </div>
                <div class="dingdanotem" @click="goorder('Paid')">
                  <div class="dingdaitip" :class="{'dingdaitip1':ordernum.unreceivedTotal>100}" v-if="ordernum.unreceivedTotal>0" style="">{{ ordernum.unreceivedTotal }}</div>
                  <img src="../images/daishouh.png" class="dingdanotemimg" mode="heightFix" alt="">
                  <div class="dingdanotemtet">待收货</div>
                </div>
                <div class="dingdanotem" @click="goorder('Expired')">
                  <div class="dingdaitip" :class="{'dingdaitip1':ordernum.cancelTotal>100}" v-if="ordernum.cancelTotal>0" style="">{{  ordernum.cancelTotal  }}</div>
                  <img src="../images/tuikuan.png" class="dingdanotemimg" mode="heightFix" alt="">
                  <div class="dingdanotemtet">已取消</div>
                </div>
              </div>
             </div>
            <div class="per_list">
                <van-cell is-link to="/myprofile" :border="false"  class="vells">
                    <template #title>
                        <van-row type="flex" align="center">
                        <!-- <span class="iconfont icon-weibiaoti3"></span> -->
                      <span class="custom-title">个人信息</span>
                      <!-- <image
                        src="../images/jiantou.png"
                        mode="scaleToFill"
                        class="jiantous"
                      /> -->
                    </van-row>
                    </template>
                  </van-cell>
                  <van-cell is-link to="/address" :border="false" class="vells">
                    <template #title>
                        <van-row type="flex" align="center">
                        <!-- <span class="iconfont icon-dingdan"></span> -->
                      <span class="custom-title"> 收货地址</span>
                    </van-row>
                    </template>
                  </van-cell>
                  <!-- <van-cell is-link to="/changepasd" :border="false">
                    <template #title>
                        <van-row type="flex" align="center">
                        <span class="iconfont icon-mima"></span>
                      <span class="custom-title">修改密码</span>
                    </van-row>
                    </template>
                  </van-cell> -->
                  <van-cell is-link to="/voucher" :border="false" class="vells">
                    <template #title>
                        <van-row type="flex" align="center">
                        <!-- <span class="iconfont icon-youhuiquan"></span> -->
                      <span class="custom-title">优惠券</span>
                    </van-row>
                    </template>
                  </van-cell>
                   <van-cell is-link :border="false" v-on:click="logout()">
                    <template #title>
                        <van-row type="flex" align="center">
                        <!-- <span class="iconfont icon-review"></span> -->
                      <span class="custom-title">退出登录</span>
                    </van-row>
                    </template>
                  </van-cell>
                  <!-- <van-cell is-link to="/Orders">
                    <template #title>
                        <van-row type="flex" align="center">
                        <span class="iconfont icon-dingdan"></span>
                      <span class="custom-title">我的订单</span>
                    </van-row>
                    </template>
                  </van-cell> -->
                  <!-- <van-cell is-link to="/reviews">
                    <template #title>
                        <van-row type="flex" align="center">
                        <span class="iconfont icon-review"></span>
                      <span class="custom-title">我的评论</span>
                    </van-row>
                    </template>
                  </van-cell> -->
                  <van-cell value="" />
            </div>
            <!-- <van-row type="flex" align="center" justify="center">
              <van-col span="8">
                <van-button block size="small" type="default" v-on:click="logout()">退出</van-button>
              </van-col>
            </van-row> -->
        </div>
        <coupons-box v-if="user_coupons.length > 0" :user_coupons="user_coupons" :source="'close'"></coupons-box>
        <v-foot></v-foot>
        <!-- <van-tabbar route active-color="#000000" >
          <van-tabbar-item replace to="/" icon="home-o">首页</van-tabbar-item>
          <van-tabbar-item replace to="/kefu" icon="service-o">客服</van-tabbar-item>
          <van-tabbar-item replace to="/carts" icon="cart-o">购物车</van-tabbar-item>
          <van-tabbar-item replace to="/personal" icon="contact-o">我的</van-tabbar-item>
        </van-tabbar> -->
    </div>
</template>
<script>
    export default {
        components: {},
        created(){
          this.user_info = this.getUserInfo(true);
          
        },
        mounted(){
          this.getoeder()
          this.getjiant()
        },
        data() {
            return {
                "user_info":false,
                user_coupons: [],
                reg: '',
                ordernum:{},
                iframeSrc:'https://kf.renguokeji.com/kefu/?app=lishun&amp;extra=eyJpZCI6IjljMjA3Yjk1Y2FhOWUzZWE2NmVlYmIxZjNmNDk0ZjE3IiwidXNlcl9pZCI6IjljMjA3Yjk1Y2FhOWUzZWE2NmVlYmIxZjNmNDk0ZjE3IiwiZGV2aWNlX2lkIjoiOWMyMDdiOTVjYWE5ZTNlYTY2ZWViYjFmM2Y0OTRmMTciLCJwbGF0Zm9ybSI6ImFuZHJvaW'
            }
        },
        methods: {
          getjiant(){
          this.GET("api/agreement/maidian?type=personal", function (data) {
            if (data.code == 0) {
              console.log(data);
            }
          });
        },
          tokf(){
            window.open(this.iframeSrc)
          },
          getoeder(){
            let that=this
            this.GET('api/Order/OrderStatus',{},function(res){
              console.log('res',res)
              if(res.code==0){
                console.log(12,res.data);
                that.ordernum=res.data
                console.log('this.ordernuma',res.data);

              }
            })
          },
          goorder(e){
            this.$router.push({
              path:'/Orders',
              query:{
                name:e
              }
            })
          },
			logout(){
				var _this = this;
				this.POST("api/user/loginout",{},function(d){
					window.console.log(d);
					_this.$router.push('login');
				});
				this.setUserInfo(-1);
			},
        },
    }
</script>
<style scoped>

.dingdan{
  width: 90%;
  /* height: 80px; */
  /* background: red; */
  margin: 0 auto;
  margin-top: 30px;
}
.jiantous{
  height: 14px;
}
.dingdans{
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px
}
.dingdanotemtet{
font-weight: bold;
font-size: 14px;
color: #14142B;
letter-spacing: 1px;
margin-top: 8px;
}
.dingdanotemimg{
  height: 24px;
}
.dingdanotem{
  width: 20%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
  position: relative;
  
}
.dingdaitip{
  width: 18px;
  height: 18px;
  /* padding: 2px; */
  background-color: #FF0C0C;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: -5px;
  right: 12px;
  color: #fff;
  font-size: 12px;
  border-radius: 50%;
}
.dingdaitip1{
  width: 22px;
  height: 22px;
}
.dingdannan{
font-weight: bold;
font-size: 18px;
color: #14142B;
letter-spacing: 1px;
}
.ykf{
  height: 42px;
  position: absolute ;
  right: 30px;
  top: 60px;
}
.vells{
  margin-bottom: 10px;

}

</style>